// Rupee display, sign-aware (HRA-11).
//
// Moved out of components/people.tsx, which still re-exports both, so no caller
// changes. Two formatters, one job each:
//
//   fmtINR     "₹1.25 L"    compact — a HEADLINE figure (a tile, a caption)
//   fmtINRFull "₹1,25,000"  exact, Indian grouping — anything reconciled: every
//                           table column, a register, a figure beside a transfer
//
// Neither had a negative branch, so a clawback printed "₹-5000" — ASCII hyphen,
// sign inside the currency, and past the abbreviation thresholds, which only test
// `n >= …`. A negative now reads "−₹5,000": U+2212, the glyph the register's
// Deduction column already prints, placed where that column puts it and where
// Intl's en-IN currency format does, so an Adjustment and a Deduction in one row
// read alike. Zero is unsigned.

const MINUS = '−';

/** Compact rupees for a headline: ₹ Cr / L / K. Negative → "−₹4K". */
export const fmtINR = (n: number): string => {
  if (n < 0) return MINUS + fmtINR(-n);
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  if (n >= 1e3) return `₹${(n / 1e3).toFixed(0)}K`;
  return `₹${n}`;
};

/** Exact rupees with Indian grouping, for any figure someone reconciles. Negative → "−₹5,000". */
export const fmtINRFull = (n: number): string =>
  (n < 0 ? MINUS : '') + '₹' + Math.abs(n).toLocaleString('en-IN');
